import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Upgrade = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Upgrade" {...props}>
    <path d="M11.3691 6.22461C11.7619 5.90426 12.3409 5.92685 12.707 6.29297L16.707 10.293C17.0976 10.6835 17.0976 11.3165 16.707 11.707C16.3165 12.0976 15.6835 12.0976 15.293 11.707L13 9.41406V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V9.41406L8.70703 11.707C8.31651 12.0976 7.68349 12.0976 7.29297 11.707C6.90244 11.3165 6.90244 10.6835 7.29297 10.293L11.293 6.29297L11.3691 6.22461Z" fill="#000" /><path fillRule="evenodd" clipRule="evenodd" d="M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z" fill="#000" />
  </StyledIcon>
));

Upgrade.displayName = 'Upgrade';

export { Upgrade };
